﻿import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Card,
  CardHeader,
  IconButton,
  List,
  Menu,
  MenuItem,
  Rating,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { useSelector } from "react-redux";
import { FETCH_PRODUCT_RATINGS } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { BIRed } from "../../assets/helpers";
import defaultUserProfilePic from "../../assets/images/avtar_placeholder.jpeg";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ReviewInputModal from "../common/ReviewInputModal";
import { useDispatch } from "react-redux";
import { setShowReport } from "../../redux/actions/actions";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import Emptydata from "../common/Emptydata";
import { English } from "../../constant/EnglishFallback";
import Pages from "../../constant/ReportModel";

function ProductReviewSection({ id }) {
  const { loginData, multiLanguageData, reportSuccess, reportData } = useSelector(
    (state) => state?.main
  );
  const dispatch = useDispatch();
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const [recordId, setRecordId] = useState(0);
  const [reviewData, setReviewData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [showAddReviewModal, setShowAddReviewModal] = useState(false);

  const LanguageData = multiLanguageData?.Products || {};
  const {
    TEXT_WRITE_A_REVIEW = English.Products.TEXT_WRITE_A_REVIEW,
    TEXT_NO_INFO_REVIEW = English.Products.TEXT_NO_INFO_REVIEW,
    BUTTON_REPORT = English.Products.BUTTON_REPORT
  } = LanguageData || {};

  useEffect(() => {
    getInitialData();
  }, []);

  // after report refresh the only company list
  useEffect(() => {
    if (reportSuccess) {
      // if (reportData?.AppScreenId === Pages?.companies?.id) {
        let reportObj = {
          showReport: false,
          recordId: 0,
          name: "",
          AppScreenId: 0
        };
        dispatch(setShowReport(reportObj));
        getInitialData();
      // }
    }
  }, [reportSuccess]);

  const getInitialData = async () => {
    setIsLoading(true);
    await getReviewData();
    setIsLoading(false);
  };

  const getReviewData = async () => {
    try {
      const obj = {
        SearchList: [{ ProductId: id }],
        userId: currentUserId,
        FetchAllowedRecordsOnly: true
      };
      const res = await Postrequestcall(FETCH_PRODUCT_RATINGS, obj, loginData?.accessToken);
      let resData = res?.data?.data ?? [];
      setReviewData(() => resData?.reverse());
    } catch (error) {
      console.log("getReviewData-> Error Fetching Product Rating: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const onWriteReviewClick = (event) => {
    event.target.blur();
    setShowAddReviewModal(true);
  };

  const handleOpenReportModal = () => {
    setMoreMenuAnchorEl(null);
    let reportObj = {
      showReport: true,
      name: Pages?.productReview?.name,
      AppScreenId: Pages?.productReview?.id,
      recordId: recordId ?? 0
    };
    dispatch(setShowReport(reportObj));
  };

  const NoInformation = () => {
    return (
      <Stack sx={{ height: "100%" }}>
        <Box className="empty-data-card">
          <Emptydata
            icon={<BusinessCenterIcon className="emptydata-icon" />}
            firstText={TEXT_NO_INFO_REVIEW}
          />
        </Box>
      </Stack>
    );
  };

  const renderReviews = () => {
    return (
      <>
        <Stack sx={{ gap: 1.5 }} >
          <Card className="pagelist-content" sx={{ p: 1.5, backgroundColor: "#f2f2f2" }}>
            <Stack direction={"row"} sx={{ alignItems: "center" }} spacing={1.5}>
              <Avatar alt="Profile Picture" src={loginData?.pictureUrl} />
              <TextField
                variant="outlined"
                fullWidth
                onClick={onWriteReviewClick}
                placeholder={TEXT_WRITE_A_REVIEW}
              />
            </Stack>
          </Card>
          {reviewData?.length > 0 ? (
            <List disablePadding>
              <Stack sx={{ gap: 1 }} >
                {reviewData?.map((review, index) => (
                  <Card className="pagelist-content" key={index}>
                    <CardHeader
                      avatar={
                        <Avatar
                          alt="Profile Picture"
                          src={review.createdByPictureUrl ?? defaultUserProfilePic}
                        />
                      }
                      title={review?.createdByUser}
                      subheader={review?.tradeName}
                      action={
                        <div>
                          <IconButton
                            aria-label="settings"
                            onClick={(event) => {
                              setRecordId(review.id);
                              setMoreMenuAnchorEl(event.currentTarget);
                            }}>
                            <MoreVertIcon />
                          </IconButton>
                        </div>
                      }
                    />
                    <Box sx={{ pt: 0,  p: 2 }} >
                      <Rating name="read-only" value={review?.rating} readOnly />
                      {review?.comments && <Typography>{review?.comments}</Typography>}
                    </Box>
                  </Card>
                ))}
              </Stack>
              <Menu
                anchorEl={moreMenuAnchorEl}
                open={Boolean(moreMenuAnchorEl)}
                onClose={() => setMoreMenuAnchorEl(null)}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}>
                <MenuItem onClick={() => handleOpenReportModal()} style={{ color: BIRed }} dense>
                  {BUTTON_REPORT}
                </MenuItem>
              </Menu>
            </List>
          ) : (
            <NoInformation />
          )}
        </Stack>
      </>
    );
  };

  return (
    <Box className="main-content-card-list">
      <Card className="pagelist-content" sx={{ p: 2, height: "100%" }}>
        {isLoading ? <Loader /> : renderReviews()}
        {showAddReviewModal && (
          <ReviewInputModal
            open={showAddReviewModal}
            onClose={() => {
              setShowAddReviewModal(false);
            }}
            mainId={id}
            onSave={() => {
              setShowAddReviewModal(false);
              setIsLoading(true);
              getReviewData();
            }}
          />
        )}
      </Card>
    </Box>
  );
}

export default ProductReviewSection;

